// extracted by mini-css-extract-plugin
module.exports = {"Visual":"Visual_Visual__347lh","FormStyle":"Visual_FormStyle__1DfM5","column":"Visual_column__314um","Note":"Visual_Note__3azM2","returnText":"Visual_returnText__3Btrr"};